/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuperRouteImport } from './routes/_super'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as HomeRouteImport } from './routes/_home'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as _404RouteImport } from './routes/__404'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as HomeWaitlistRouteImport } from './routes/_home/waitlist'
import { Route as AuthenticatedSubscriptionsRouteImport } from './routes/_authenticated/subscriptions'
import { Route as AuthenticatedSubscriptionSuccessRouteImport } from './routes/_authenticated/subscription-success'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedReleaseNotesRouteImport } from './routes/_authenticated/release-notes'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedLogisticsRouteImport } from './routes/_authenticated/logistics'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCompleteProfileRouteImport } from './routes/_authenticated/complete-profile'
import { Route as AuthenticatedClientsRouteImport } from './routes/_authenticated/clients'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as SuperSuperWaitlistRouteImport } from './routes/_super/super/waitlist'
import { Route as SuperSuperUsersRouteImport } from './routes/_super/super/users'
import { Route as SuperSuperSubscriptionsRouteImport } from './routes/_super/super/subscriptions'
import { Route as SuperSuperSettingsRouteImport } from './routes/_super/super/settings'
import { Route as SuperSuperPlansRouteImport } from './routes/_super/super/plans'
import { Route as SuperSuperDashboardRouteImport } from './routes/_super/super/dashboard'
import { Route as SuperSuperCompaniesRouteImport } from './routes/_super/super/companies'
import { Route as SuperSuperLayoutRouteImport } from './routes/_super/super/_layout'
import { Route as PublicVerifyQrCodeRouteImport } from './routes/_public/verify.$qrCode'
import { Route as PublicTrackCodeRouteImport } from './routes/_public/track.$code'
import { Route as PublicAuthSignUpRouteImport } from './routes/_public/auth/sign-up'
import { Route as PublicAuthSignInRouteImport } from './routes/_public/auth/sign-in'
import { Route as PublicAuthResetPasswordRouteImport } from './routes/_public/auth/reset-password'
import { Route as PublicAuthFirstTimeLoginRouteImport } from './routes/_public/auth/first-time-login'
import { Route as AuthenticatedSettingsLayoutRouteImport } from './routes/_authenticated/settings/_layout'
import { Route as AuthenticatedLogisticsPackagesRouteImport } from './routes/_authenticated/logistics/packages'
import { Route as AuthenticatedLogisticsOrdersRouteImport } from './routes/_authenticated/logistics/orders'
import { Route as AuthenticatedLogisticsContainersRouteImport } from './routes/_authenticated/logistics/containers'
import { Route as AuthenticatedLogisticsBoxDeliveriesRouteImport } from './routes/_authenticated/logistics/box-deliveries'
import { Route as SuperSuperControlPanelIndexRouteImport } from './routes/_super/super/control-panel/index'
import { Route as AuthenticatedSettingsLayoutIndexRouteImport } from './routes/_authenticated/settings/_layout/index'
import { Route as AuthenticatedLogisticsPackagesIndexRouteImport } from './routes/_authenticated/logistics/packages/index'
import { Route as AuthenticatedLogisticsOrdersIndexRouteImport } from './routes/_authenticated/logistics/orders/index'
import { Route as AuthenticatedLogisticsOrder_paymentsIndexRouteImport } from './routes/_authenticated/logistics/order_payments/index'
import { Route as AuthenticatedLogisticsBoxDeliveriesIndexRouteImport } from './routes/_authenticated/logistics/box-deliveries/index'
import { Route as SuperSuperControlPanelCompanyIdRouteImport } from './routes/_super/super/control-panel.$companyId'
import { Route as PublicTrackOrderCodeRouteImport } from './routes/_public/track/order.$code'
import { Route as AuthenticatedSettingsLayoutUsersRouteImport } from './routes/_authenticated/settings/_layout/users'
import { Route as AuthenticatedSettingsLayoutTrashRouteImport } from './routes/_authenticated/settings/_layout/trash'
import { Route as AuthenticatedSettingsLayoutSubscriptionRouteImport } from './routes/_authenticated/settings/_layout/subscription'
import { Route as AuthenticatedSettingsLayoutShippingRoutesRouteImport } from './routes/_authenticated/settings/_layout/shipping-routes'
import { Route as AuthenticatedSettingsLayoutRolesRouteImport } from './routes/_authenticated/settings/_layout/roles'
import { Route as AuthenticatedSettingsLayoutPaymentMethodsRouteImport } from './routes/_authenticated/settings/_layout/payment-methods'
import { Route as AuthenticatedSettingsLayoutNotificationsRouteImport } from './routes/_authenticated/settings/_layout/notifications'
import { Route as AuthenticatedSettingsLayoutNomenclaturesRouteImport } from './routes/_authenticated/settings/_layout/nomenclatures'
import { Route as AuthenticatedSettingsLayoutLogisticsRouteImport } from './routes/_authenticated/settings/_layout/logistics'
import { Route as AuthenticatedSettingsLayoutContainersRouteImport } from './routes/_authenticated/settings/_layout/containers'
import { Route as AuthenticatedSettingsLayoutCarriersRouteImport } from './routes/_authenticated/settings/_layout/carriers'
import { Route as AuthenticatedSettingsLayoutCalendarsRouteImport } from './routes/_authenticated/settings/_layout/calendars'
import { Route as AuthenticatedSettingsLayoutBranchesRouteImport } from './routes/_authenticated/settings/_layout/branches'
import { Route as AuthenticatedSettingsLayoutBoxTypesRouteImport } from './routes/_authenticated/settings/_layout/box-types'
import { Route as AuthenticatedReportsIdBuilderRouteImport } from './routes/_authenticated/reports/$id.builder'
import { Route as AuthenticatedLogisticsPackagesIdRouteImport } from './routes/_authenticated/logistics/packages/$id'
import { Route as AuthenticatedLogisticsOrdersNewRouteImport } from './routes/_authenticated/logistics/orders/new'
import { Route as AuthenticatedLogisticsContainersNewRouteImport } from './routes/_authenticated/logistics/containers/new'
import { Route as AuthenticatedLogisticsContainersListRouteImport } from './routes/_authenticated/logistics/containers/_list'
import { Route as AuthenticatedLogisticsContainersListIndexRouteImport } from './routes/_authenticated/logistics/containers/_list/index'
import { Route as SuperSuperControlPanelCompanyIdUsersRouteImport } from './routes/_super/super/control-panel.$companyId.users'
import { Route as SuperSuperControlPanelCompanyIdUsageRouteImport } from './routes/_super/super/control-panel.$companyId.usage'
import { Route as SuperSuperControlPanelCompanyIdSubscriptionRouteImport } from './routes/_super/super/control-panel.$companyId.subscription'
import { Route as SuperSuperControlPanelCompanyIdOverviewRouteImport } from './routes/_super/super/control-panel.$companyId.overview'
import { Route as SuperSuperControlPanelCompanyIdHistoryRouteImport } from './routes/_super/super/control-panel.$companyId.history'
import { Route as AuthenticatedLogisticsOrdersIdEditRouteImport } from './routes/_authenticated/logistics/orders/$id.edit'
import { Route as AuthenticatedLogisticsContainersListKanbanRouteImport } from './routes/_authenticated/logistics/containers/_list/kanban'
import { Route as AuthenticatedLogisticsContainersListCalendarRouteImport } from './routes/_authenticated/logistics/containers/_list/calendar'
import { Route as AuthenticatedLogisticsContainersIdEditRouteImport } from './routes/_authenticated/logistics/containers/$id.edit'

const SuperRoute = SuperRouteImport.update({
  id: '/_super',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/_home',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const _404Route = _404RouteImport.update({
  id: '/__404',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRoute,
} as any)
const HomeWaitlistRoute = HomeWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => HomeRoute,
} as any)
const AuthenticatedSubscriptionsRoute =
  AuthenticatedSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSubscriptionSuccessRoute =
  AuthenticatedSubscriptionSuccessRouteImport.update({
    id: '/subscription-success',
    path: '/subscription-success',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReleaseNotesRoute =
  AuthenticatedReleaseNotesRouteImport.update({
    id: '/release-notes',
    path: '/release-notes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLogisticsRoute = AuthenticatedLogisticsRouteImport.update({
  id: '/logistics',
  path: '/logistics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompleteProfileRoute =
  AuthenticatedCompleteProfileRouteImport.update({
    id: '/complete-profile',
    path: '/complete-profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsRoute = AuthenticatedClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientsRoute,
  } as any)
const SuperSuperWaitlistRoute = SuperSuperWaitlistRouteImport.update({
  id: '/super/waitlist',
  path: '/super/waitlist',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperUsersRoute = SuperSuperUsersRouteImport.update({
  id: '/super/users',
  path: '/super/users',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperSubscriptionsRoute = SuperSuperSubscriptionsRouteImport.update({
  id: '/super/subscriptions',
  path: '/super/subscriptions',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperSettingsRoute = SuperSuperSettingsRouteImport.update({
  id: '/super/settings',
  path: '/super/settings',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperPlansRoute = SuperSuperPlansRouteImport.update({
  id: '/super/plans',
  path: '/super/plans',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperDashboardRoute = SuperSuperDashboardRouteImport.update({
  id: '/super/dashboard',
  path: '/super/dashboard',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperCompaniesRoute = SuperSuperCompaniesRouteImport.update({
  id: '/super/companies',
  path: '/super/companies',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperLayoutRoute = SuperSuperLayoutRouteImport.update({
  id: '/super/_layout',
  path: '/super',
  getParentRoute: () => SuperRoute,
} as any)
const PublicVerifyQrCodeRoute = PublicVerifyQrCodeRouteImport.update({
  id: '/verify/$qrCode',
  path: '/verify/$qrCode',
  getParentRoute: () => PublicRoute,
} as any)
const PublicTrackCodeRoute = PublicTrackCodeRouteImport.update({
  id: '/track/$code',
  path: '/track/$code',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthSignUpRoute = PublicAuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthSignInRoute = PublicAuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthResetPasswordRoute = PublicAuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthFirstTimeLoginRoute =
  PublicAuthFirstTimeLoginRouteImport.update({
    id: '/auth/first-time-login',
    path: '/auth/first-time-login',
    getParentRoute: () => PublicRoute,
  } as any)
const AuthenticatedSettingsLayoutRoute =
  AuthenticatedSettingsLayoutRouteImport.update({
    id: '/settings/_layout',
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLogisticsPackagesRoute =
  AuthenticatedLogisticsPackagesRouteImport.update({
    id: '/packages',
    path: '/packages',
    getParentRoute: () => AuthenticatedLogisticsRoute,
  } as any)
const AuthenticatedLogisticsOrdersRoute =
  AuthenticatedLogisticsOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthenticatedLogisticsRoute,
  } as any)
const AuthenticatedLogisticsContainersRoute =
  AuthenticatedLogisticsContainersRouteImport.update({
    id: '/containers',
    path: '/containers',
    getParentRoute: () => AuthenticatedLogisticsRoute,
  } as any)
const AuthenticatedLogisticsBoxDeliveriesRoute =
  AuthenticatedLogisticsBoxDeliveriesRouteImport.update({
    id: '/box-deliveries',
    path: '/box-deliveries',
    getParentRoute: () => AuthenticatedLogisticsRoute,
  } as any)
const SuperSuperControlPanelIndexRoute =
  SuperSuperControlPanelIndexRouteImport.update({
    id: '/super/control-panel/',
    path: '/super/control-panel/',
    getParentRoute: () => SuperRoute,
  } as any)
const AuthenticatedSettingsLayoutIndexRoute =
  AuthenticatedSettingsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedLogisticsPackagesIndexRoute =
  AuthenticatedLogisticsPackagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLogisticsPackagesRoute,
  } as any)
const AuthenticatedLogisticsOrdersIndexRoute =
  AuthenticatedLogisticsOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLogisticsOrdersRoute,
  } as any)
const AuthenticatedLogisticsOrder_paymentsIndexRoute =
  AuthenticatedLogisticsOrder_paymentsIndexRouteImport.update({
    id: '/order_payments/',
    path: '/order_payments/',
    getParentRoute: () => AuthenticatedLogisticsRoute,
  } as any)
const AuthenticatedLogisticsBoxDeliveriesIndexRoute =
  AuthenticatedLogisticsBoxDeliveriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLogisticsBoxDeliveriesRoute,
  } as any)
const SuperSuperControlPanelCompanyIdRoute =
  SuperSuperControlPanelCompanyIdRouteImport.update({
    id: '/super/control-panel/$companyId',
    path: '/super/control-panel/$companyId',
    getParentRoute: () => SuperRoute,
  } as any)
const PublicTrackOrderCodeRoute = PublicTrackOrderCodeRouteImport.update({
  id: '/track/order/$code',
  path: '/track/order/$code',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedSettingsLayoutUsersRoute =
  AuthenticatedSettingsLayoutUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutTrashRoute =
  AuthenticatedSettingsLayoutTrashRouteImport.update({
    id: '/trash',
    path: '/trash',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutSubscriptionRoute =
  AuthenticatedSettingsLayoutSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutShippingRoutesRoute =
  AuthenticatedSettingsLayoutShippingRoutesRouteImport.update({
    id: '/shipping-routes',
    path: '/shipping-routes',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutRolesRoute =
  AuthenticatedSettingsLayoutRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutPaymentMethodsRoute =
  AuthenticatedSettingsLayoutPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutNotificationsRoute =
  AuthenticatedSettingsLayoutNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutNomenclaturesRoute =
  AuthenticatedSettingsLayoutNomenclaturesRouteImport.update({
    id: '/nomenclatures',
    path: '/nomenclatures',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutLogisticsRoute =
  AuthenticatedSettingsLayoutLogisticsRouteImport.update({
    id: '/logistics',
    path: '/logistics',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutContainersRoute =
  AuthenticatedSettingsLayoutContainersRouteImport.update({
    id: '/containers',
    path: '/containers',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCarriersRoute =
  AuthenticatedSettingsLayoutCarriersRouteImport.update({
    id: '/carriers',
    path: '/carriers',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCalendarsRoute =
  AuthenticatedSettingsLayoutCalendarsRouteImport.update({
    id: '/calendars',
    path: '/calendars',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutBranchesRoute =
  AuthenticatedSettingsLayoutBranchesRouteImport.update({
    id: '/branches',
    path: '/branches',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutBoxTypesRoute =
  AuthenticatedSettingsLayoutBoxTypesRouteImport.update({
    id: '/box-types',
    path: '/box-types',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedReportsIdBuilderRoute =
  AuthenticatedReportsIdBuilderRouteImport.update({
    id: '/$id/builder',
    path: '/$id/builder',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedLogisticsPackagesIdRoute =
  AuthenticatedLogisticsPackagesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedLogisticsPackagesRoute,
  } as any)
const AuthenticatedLogisticsOrdersNewRoute =
  AuthenticatedLogisticsOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedLogisticsOrdersRoute,
  } as any)
const AuthenticatedLogisticsContainersNewRoute =
  AuthenticatedLogisticsContainersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedLogisticsContainersRoute,
  } as any)
const AuthenticatedLogisticsContainersListRoute =
  AuthenticatedLogisticsContainersListRouteImport.update({
    id: '/_list',
    getParentRoute: () => AuthenticatedLogisticsContainersRoute,
  } as any)
const AuthenticatedLogisticsContainersListIndexRoute =
  AuthenticatedLogisticsContainersListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLogisticsContainersListRoute,
  } as any)
const SuperSuperControlPanelCompanyIdUsersRoute =
  SuperSuperControlPanelCompanyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdUsageRoute =
  SuperSuperControlPanelCompanyIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdSubscriptionRoute =
  SuperSuperControlPanelCompanyIdSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdOverviewRoute =
  SuperSuperControlPanelCompanyIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdHistoryRoute =
  SuperSuperControlPanelCompanyIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const AuthenticatedLogisticsOrdersIdEditRoute =
  AuthenticatedLogisticsOrdersIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedLogisticsOrdersRoute,
  } as any)
const AuthenticatedLogisticsContainersListKanbanRoute =
  AuthenticatedLogisticsContainersListKanbanRouteImport.update({
    id: '/kanban',
    path: '/kanban',
    getParentRoute: () => AuthenticatedLogisticsContainersListRoute,
  } as any)
const AuthenticatedLogisticsContainersListCalendarRoute =
  AuthenticatedLogisticsContainersListCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedLogisticsContainersListRoute,
  } as any)
const AuthenticatedLogisticsContainersIdEditRoute =
  AuthenticatedLogisticsContainersIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedLogisticsContainersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/clients': typeof AuthenticatedClientsRouteWithChildren
  '/complete-profile': typeof AuthenticatedCompleteProfileRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/logistics': typeof AuthenticatedLogisticsRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/release-notes': typeof AuthenticatedReleaseNotesRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/subscription-success': typeof AuthenticatedSubscriptionSuccessRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/waitlist': typeof HomeWaitlistRoute
  '/': typeof HomeIndexRoute
  '/logistics/box-deliveries': typeof AuthenticatedLogisticsBoxDeliveriesRouteWithChildren
  '/logistics/containers': typeof AuthenticatedLogisticsContainersListRouteWithChildren
  '/logistics/orders': typeof AuthenticatedLogisticsOrdersRouteWithChildren
  '/logistics/packages': typeof AuthenticatedLogisticsPackagesRouteWithChildren
  '/settings': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/auth/first-time-login': typeof PublicAuthFirstTimeLoginRoute
  '/auth/reset-password': typeof PublicAuthResetPasswordRoute
  '/auth/sign-in': typeof PublicAuthSignInRoute
  '/auth/sign-up': typeof PublicAuthSignUpRoute
  '/track/$code': typeof PublicTrackCodeRoute
  '/verify/$qrCode': typeof PublicVerifyQrCodeRoute
  '/super': typeof SuperSuperLayoutRoute
  '/super/companies': typeof SuperSuperCompaniesRoute
  '/super/dashboard': typeof SuperSuperDashboardRoute
  '/super/plans': typeof SuperSuperPlansRoute
  '/super/settings': typeof SuperSuperSettingsRoute
  '/super/subscriptions': typeof SuperSuperSubscriptionsRoute
  '/super/users': typeof SuperSuperUsersRoute
  '/super/waitlist': typeof SuperSuperWaitlistRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/logistics/containers/new': typeof AuthenticatedLogisticsContainersNewRoute
  '/logistics/orders/new': typeof AuthenticatedLogisticsOrdersNewRoute
  '/logistics/packages/$id': typeof AuthenticatedLogisticsPackagesIdRoute
  '/reports/$id/builder': typeof AuthenticatedReportsIdBuilderRoute
  '/settings/box-types': typeof AuthenticatedSettingsLayoutBoxTypesRoute
  '/settings/branches': typeof AuthenticatedSettingsLayoutBranchesRoute
  '/settings/calendars': typeof AuthenticatedSettingsLayoutCalendarsRoute
  '/settings/carriers': typeof AuthenticatedSettingsLayoutCarriersRoute
  '/settings/containers': typeof AuthenticatedSettingsLayoutContainersRoute
  '/settings/logistics': typeof AuthenticatedSettingsLayoutLogisticsRoute
  '/settings/nomenclatures': typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  '/settings/notifications': typeof AuthenticatedSettingsLayoutNotificationsRoute
  '/settings/payment-methods': typeof AuthenticatedSettingsLayoutPaymentMethodsRoute
  '/settings/roles': typeof AuthenticatedSettingsLayoutRolesRoute
  '/settings/shipping-routes': typeof AuthenticatedSettingsLayoutShippingRoutesRoute
  '/settings/subscription': typeof AuthenticatedSettingsLayoutSubscriptionRoute
  '/settings/trash': typeof AuthenticatedSettingsLayoutTrashRoute
  '/settings/users': typeof AuthenticatedSettingsLayoutUsersRoute
  '/track/order/$code': typeof PublicTrackOrderCodeRoute
  '/super/control-panel/$companyId': typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  '/logistics/box-deliveries/': typeof AuthenticatedLogisticsBoxDeliveriesIndexRoute
  '/logistics/order_payments': typeof AuthenticatedLogisticsOrder_paymentsIndexRoute
  '/logistics/orders/': typeof AuthenticatedLogisticsOrdersIndexRoute
  '/logistics/packages/': typeof AuthenticatedLogisticsPackagesIndexRoute
  '/settings/': typeof AuthenticatedSettingsLayoutIndexRoute
  '/super/control-panel': typeof SuperSuperControlPanelIndexRoute
  '/logistics/containers/$id/edit': typeof AuthenticatedLogisticsContainersIdEditRoute
  '/logistics/containers/calendar': typeof AuthenticatedLogisticsContainersListCalendarRoute
  '/logistics/containers/kanban': typeof AuthenticatedLogisticsContainersListKanbanRoute
  '/logistics/orders/$id/edit': typeof AuthenticatedLogisticsOrdersIdEditRoute
  '/super/control-panel/$companyId/history': typeof SuperSuperControlPanelCompanyIdHistoryRoute
  '/super/control-panel/$companyId/overview': typeof SuperSuperControlPanelCompanyIdOverviewRoute
  '/super/control-panel/$companyId/subscription': typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  '/super/control-panel/$companyId/usage': typeof SuperSuperControlPanelCompanyIdUsageRoute
  '/super/control-panel/$companyId/users': typeof SuperSuperControlPanelCompanyIdUsersRoute
  '/logistics/containers/': typeof AuthenticatedLogisticsContainersListIndexRoute
}
export interface FileRoutesByTo {
  '/complete-profile': typeof AuthenticatedCompleteProfileRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/logistics': typeof AuthenticatedLogisticsRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/release-notes': typeof AuthenticatedReleaseNotesRoute
  '/subscription-success': typeof AuthenticatedSubscriptionSuccessRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/waitlist': typeof HomeWaitlistRoute
  '/': typeof HomeIndexRoute
  '/logistics/containers': typeof AuthenticatedLogisticsContainersListIndexRoute
  '/auth/first-time-login': typeof PublicAuthFirstTimeLoginRoute
  '/auth/reset-password': typeof PublicAuthResetPasswordRoute
  '/auth/sign-in': typeof PublicAuthSignInRoute
  '/auth/sign-up': typeof PublicAuthSignUpRoute
  '/track/$code': typeof PublicTrackCodeRoute
  '/verify/$qrCode': typeof PublicVerifyQrCodeRoute
  '/super': typeof SuperSuperLayoutRoute
  '/super/companies': typeof SuperSuperCompaniesRoute
  '/super/dashboard': typeof SuperSuperDashboardRoute
  '/super/plans': typeof SuperSuperPlansRoute
  '/super/settings': typeof SuperSuperSettingsRoute
  '/super/subscriptions': typeof SuperSuperSubscriptionsRoute
  '/super/users': typeof SuperSuperUsersRoute
  '/super/waitlist': typeof SuperSuperWaitlistRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/logistics/containers/new': typeof AuthenticatedLogisticsContainersNewRoute
  '/logistics/orders/new': typeof AuthenticatedLogisticsOrdersNewRoute
  '/logistics/packages/$id': typeof AuthenticatedLogisticsPackagesIdRoute
  '/reports/$id/builder': typeof AuthenticatedReportsIdBuilderRoute
  '/settings/box-types': typeof AuthenticatedSettingsLayoutBoxTypesRoute
  '/settings/branches': typeof AuthenticatedSettingsLayoutBranchesRoute
  '/settings/calendars': typeof AuthenticatedSettingsLayoutCalendarsRoute
  '/settings/carriers': typeof AuthenticatedSettingsLayoutCarriersRoute
  '/settings/containers': typeof AuthenticatedSettingsLayoutContainersRoute
  '/settings/logistics': typeof AuthenticatedSettingsLayoutLogisticsRoute
  '/settings/nomenclatures': typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  '/settings/notifications': typeof AuthenticatedSettingsLayoutNotificationsRoute
  '/settings/payment-methods': typeof AuthenticatedSettingsLayoutPaymentMethodsRoute
  '/settings/roles': typeof AuthenticatedSettingsLayoutRolesRoute
  '/settings/shipping-routes': typeof AuthenticatedSettingsLayoutShippingRoutesRoute
  '/settings/subscription': typeof AuthenticatedSettingsLayoutSubscriptionRoute
  '/settings/trash': typeof AuthenticatedSettingsLayoutTrashRoute
  '/settings/users': typeof AuthenticatedSettingsLayoutUsersRoute
  '/track/order/$code': typeof PublicTrackOrderCodeRoute
  '/super/control-panel/$companyId': typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  '/logistics/box-deliveries': typeof AuthenticatedLogisticsBoxDeliveriesIndexRoute
  '/logistics/order_payments': typeof AuthenticatedLogisticsOrder_paymentsIndexRoute
  '/logistics/orders': typeof AuthenticatedLogisticsOrdersIndexRoute
  '/logistics/packages': typeof AuthenticatedLogisticsPackagesIndexRoute
  '/settings': typeof AuthenticatedSettingsLayoutIndexRoute
  '/super/control-panel': typeof SuperSuperControlPanelIndexRoute
  '/logistics/containers/$id/edit': typeof AuthenticatedLogisticsContainersIdEditRoute
  '/logistics/containers/calendar': typeof AuthenticatedLogisticsContainersListCalendarRoute
  '/logistics/containers/kanban': typeof AuthenticatedLogisticsContainersListKanbanRoute
  '/logistics/orders/$id/edit': typeof AuthenticatedLogisticsOrdersIdEditRoute
  '/super/control-panel/$companyId/history': typeof SuperSuperControlPanelCompanyIdHistoryRoute
  '/super/control-panel/$companyId/overview': typeof SuperSuperControlPanelCompanyIdOverviewRoute
  '/super/control-panel/$companyId/subscription': typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  '/super/control-panel/$companyId/usage': typeof SuperSuperControlPanelCompanyIdUsageRoute
  '/super/control-panel/$companyId/users': typeof SuperSuperControlPanelCompanyIdUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/__404': typeof _404Route
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_home': typeof HomeRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_super': typeof SuperRouteWithChildren
  '/_authenticated/clients': typeof AuthenticatedClientsRouteWithChildren
  '/_authenticated/complete-profile': typeof AuthenticatedCompleteProfileRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/logistics': typeof AuthenticatedLogisticsRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/release-notes': typeof AuthenticatedReleaseNotesRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/subscription-success': typeof AuthenticatedSubscriptionSuccessRoute
  '/_authenticated/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/_home/waitlist': typeof HomeWaitlistRoute
  '/_home/': typeof HomeIndexRoute
  '/_authenticated/logistics/box-deliveries': typeof AuthenticatedLogisticsBoxDeliveriesRouteWithChildren
  '/_authenticated/logistics/containers': typeof AuthenticatedLogisticsContainersRouteWithChildren
  '/_authenticated/logistics/orders': typeof AuthenticatedLogisticsOrdersRouteWithChildren
  '/_authenticated/logistics/packages': typeof AuthenticatedLogisticsPackagesRouteWithChildren
  '/_authenticated/settings/_layout': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/_public/auth/first-time-login': typeof PublicAuthFirstTimeLoginRoute
  '/_public/auth/reset-password': typeof PublicAuthResetPasswordRoute
  '/_public/auth/sign-in': typeof PublicAuthSignInRoute
  '/_public/auth/sign-up': typeof PublicAuthSignUpRoute
  '/_public/track/$code': typeof PublicTrackCodeRoute
  '/_public/verify/$qrCode': typeof PublicVerifyQrCodeRoute
  '/_super/super/_layout': typeof SuperSuperLayoutRoute
  '/_super/super/companies': typeof SuperSuperCompaniesRoute
  '/_super/super/dashboard': typeof SuperSuperDashboardRoute
  '/_super/super/plans': typeof SuperSuperPlansRoute
  '/_super/super/settings': typeof SuperSuperSettingsRoute
  '/_super/super/subscriptions': typeof SuperSuperSubscriptionsRoute
  '/_super/super/users': typeof SuperSuperUsersRoute
  '/_super/super/waitlist': typeof SuperSuperWaitlistRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/logistics/containers/_list': typeof AuthenticatedLogisticsContainersListRouteWithChildren
  '/_authenticated/logistics/containers/new': typeof AuthenticatedLogisticsContainersNewRoute
  '/_authenticated/logistics/orders/new': typeof AuthenticatedLogisticsOrdersNewRoute
  '/_authenticated/logistics/packages/$id': typeof AuthenticatedLogisticsPackagesIdRoute
  '/_authenticated/reports/$id/builder': typeof AuthenticatedReportsIdBuilderRoute
  '/_authenticated/settings/_layout/box-types': typeof AuthenticatedSettingsLayoutBoxTypesRoute
  '/_authenticated/settings/_layout/branches': typeof AuthenticatedSettingsLayoutBranchesRoute
  '/_authenticated/settings/_layout/calendars': typeof AuthenticatedSettingsLayoutCalendarsRoute
  '/_authenticated/settings/_layout/carriers': typeof AuthenticatedSettingsLayoutCarriersRoute
  '/_authenticated/settings/_layout/containers': typeof AuthenticatedSettingsLayoutContainersRoute
  '/_authenticated/settings/_layout/logistics': typeof AuthenticatedSettingsLayoutLogisticsRoute
  '/_authenticated/settings/_layout/nomenclatures': typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  '/_authenticated/settings/_layout/notifications': typeof AuthenticatedSettingsLayoutNotificationsRoute
  '/_authenticated/settings/_layout/payment-methods': typeof AuthenticatedSettingsLayoutPaymentMethodsRoute
  '/_authenticated/settings/_layout/roles': typeof AuthenticatedSettingsLayoutRolesRoute
  '/_authenticated/settings/_layout/shipping-routes': typeof AuthenticatedSettingsLayoutShippingRoutesRoute
  '/_authenticated/settings/_layout/subscription': typeof AuthenticatedSettingsLayoutSubscriptionRoute
  '/_authenticated/settings/_layout/trash': typeof AuthenticatedSettingsLayoutTrashRoute
  '/_authenticated/settings/_layout/users': typeof AuthenticatedSettingsLayoutUsersRoute
  '/_public/track/order/$code': typeof PublicTrackOrderCodeRoute
  '/_super/super/control-panel/$companyId': typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  '/_authenticated/logistics/box-deliveries/': typeof AuthenticatedLogisticsBoxDeliveriesIndexRoute
  '/_authenticated/logistics/order_payments/': typeof AuthenticatedLogisticsOrder_paymentsIndexRoute
  '/_authenticated/logistics/orders/': typeof AuthenticatedLogisticsOrdersIndexRoute
  '/_authenticated/logistics/packages/': typeof AuthenticatedLogisticsPackagesIndexRoute
  '/_authenticated/settings/_layout/': typeof AuthenticatedSettingsLayoutIndexRoute
  '/_super/super/control-panel/': typeof SuperSuperControlPanelIndexRoute
  '/_authenticated/logistics/containers/$id/edit': typeof AuthenticatedLogisticsContainersIdEditRoute
  '/_authenticated/logistics/containers/_list/calendar': typeof AuthenticatedLogisticsContainersListCalendarRoute
  '/_authenticated/logistics/containers/_list/kanban': typeof AuthenticatedLogisticsContainersListKanbanRoute
  '/_authenticated/logistics/orders/$id/edit': typeof AuthenticatedLogisticsOrdersIdEditRoute
  '/_super/super/control-panel/$companyId/history': typeof SuperSuperControlPanelCompanyIdHistoryRoute
  '/_super/super/control-panel/$companyId/overview': typeof SuperSuperControlPanelCompanyIdOverviewRoute
  '/_super/super/control-panel/$companyId/subscription': typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  '/_super/super/control-panel/$companyId/usage': typeof SuperSuperControlPanelCompanyIdUsageRoute
  '/_super/super/control-panel/$companyId/users': typeof SuperSuperControlPanelCompanyIdUsersRoute
  '/_authenticated/logistics/containers/_list/': typeof AuthenticatedLogisticsContainersListIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/clients'
    | '/complete-profile'
    | '/dashboard'
    | '/logistics'
    | '/profile'
    | '/release-notes'
    | '/reports'
    | '/subscription-success'
    | '/subscriptions'
    | '/waitlist'
    | '/'
    | '/logistics/box-deliveries'
    | '/logistics/containers'
    | '/logistics/orders'
    | '/logistics/packages'
    | '/settings'
    | '/auth/first-time-login'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/track/$code'
    | '/verify/$qrCode'
    | '/super'
    | '/super/companies'
    | '/super/dashboard'
    | '/super/plans'
    | '/super/settings'
    | '/super/subscriptions'
    | '/super/users'
    | '/super/waitlist'
    | '/clients/'
    | '/reports/'
    | '/logistics/containers/new'
    | '/logistics/orders/new'
    | '/logistics/packages/$id'
    | '/reports/$id/builder'
    | '/settings/box-types'
    | '/settings/branches'
    | '/settings/calendars'
    | '/settings/carriers'
    | '/settings/containers'
    | '/settings/logistics'
    | '/settings/nomenclatures'
    | '/settings/notifications'
    | '/settings/payment-methods'
    | '/settings/roles'
    | '/settings/shipping-routes'
    | '/settings/subscription'
    | '/settings/trash'
    | '/settings/users'
    | '/track/order/$code'
    | '/super/control-panel/$companyId'
    | '/logistics/box-deliveries/'
    | '/logistics/order_payments'
    | '/logistics/orders/'
    | '/logistics/packages/'
    | '/settings/'
    | '/super/control-panel'
    | '/logistics/containers/$id/edit'
    | '/logistics/containers/calendar'
    | '/logistics/containers/kanban'
    | '/logistics/orders/$id/edit'
    | '/super/control-panel/$companyId/history'
    | '/super/control-panel/$companyId/overview'
    | '/super/control-panel/$companyId/subscription'
    | '/super/control-panel/$companyId/usage'
    | '/super/control-panel/$companyId/users'
    | '/logistics/containers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/complete-profile'
    | '/dashboard'
    | '/logistics'
    | '/profile'
    | '/release-notes'
    | '/subscription-success'
    | '/subscriptions'
    | '/waitlist'
    | '/'
    | '/logistics/containers'
    | '/auth/first-time-login'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/track/$code'
    | '/verify/$qrCode'
    | '/super'
    | '/super/companies'
    | '/super/dashboard'
    | '/super/plans'
    | '/super/settings'
    | '/super/subscriptions'
    | '/super/users'
    | '/super/waitlist'
    | '/clients'
    | '/reports'
    | '/logistics/containers/new'
    | '/logistics/orders/new'
    | '/logistics/packages/$id'
    | '/reports/$id/builder'
    | '/settings/box-types'
    | '/settings/branches'
    | '/settings/calendars'
    | '/settings/carriers'
    | '/settings/containers'
    | '/settings/logistics'
    | '/settings/nomenclatures'
    | '/settings/notifications'
    | '/settings/payment-methods'
    | '/settings/roles'
    | '/settings/shipping-routes'
    | '/settings/subscription'
    | '/settings/trash'
    | '/settings/users'
    | '/track/order/$code'
    | '/super/control-panel/$companyId'
    | '/logistics/box-deliveries'
    | '/logistics/order_payments'
    | '/logistics/orders'
    | '/logistics/packages'
    | '/settings'
    | '/super/control-panel'
    | '/logistics/containers/$id/edit'
    | '/logistics/containers/calendar'
    | '/logistics/containers/kanban'
    | '/logistics/orders/$id/edit'
    | '/super/control-panel/$companyId/history'
    | '/super/control-panel/$companyId/overview'
    | '/super/control-panel/$companyId/subscription'
    | '/super/control-panel/$companyId/usage'
    | '/super/control-panel/$companyId/users'
  id:
    | '__root__'
    | '/__404'
    | '/_authenticated'
    | '/_home'
    | '/_public'
    | '/_super'
    | '/_authenticated/clients'
    | '/_authenticated/complete-profile'
    | '/_authenticated/dashboard'
    | '/_authenticated/logistics'
    | '/_authenticated/profile'
    | '/_authenticated/release-notes'
    | '/_authenticated/reports'
    | '/_authenticated/subscription-success'
    | '/_authenticated/subscriptions'
    | '/_home/waitlist'
    | '/_home/'
    | '/_authenticated/logistics/box-deliveries'
    | '/_authenticated/logistics/containers'
    | '/_authenticated/logistics/orders'
    | '/_authenticated/logistics/packages'
    | '/_authenticated/settings/_layout'
    | '/_public/auth/first-time-login'
    | '/_public/auth/reset-password'
    | '/_public/auth/sign-in'
    | '/_public/auth/sign-up'
    | '/_public/track/$code'
    | '/_public/verify/$qrCode'
    | '/_super/super/_layout'
    | '/_super/super/companies'
    | '/_super/super/dashboard'
    | '/_super/super/plans'
    | '/_super/super/settings'
    | '/_super/super/subscriptions'
    | '/_super/super/users'
    | '/_super/super/waitlist'
    | '/_authenticated/clients/'
    | '/_authenticated/reports/'
    | '/_authenticated/logistics/containers/_list'
    | '/_authenticated/logistics/containers/new'
    | '/_authenticated/logistics/orders/new'
    | '/_authenticated/logistics/packages/$id'
    | '/_authenticated/reports/$id/builder'
    | '/_authenticated/settings/_layout/box-types'
    | '/_authenticated/settings/_layout/branches'
    | '/_authenticated/settings/_layout/calendars'
    | '/_authenticated/settings/_layout/carriers'
    | '/_authenticated/settings/_layout/containers'
    | '/_authenticated/settings/_layout/logistics'
    | '/_authenticated/settings/_layout/nomenclatures'
    | '/_authenticated/settings/_layout/notifications'
    | '/_authenticated/settings/_layout/payment-methods'
    | '/_authenticated/settings/_layout/roles'
    | '/_authenticated/settings/_layout/shipping-routes'
    | '/_authenticated/settings/_layout/subscription'
    | '/_authenticated/settings/_layout/trash'
    | '/_authenticated/settings/_layout/users'
    | '/_public/track/order/$code'
    | '/_super/super/control-panel/$companyId'
    | '/_authenticated/logistics/box-deliveries/'
    | '/_authenticated/logistics/order_payments/'
    | '/_authenticated/logistics/orders/'
    | '/_authenticated/logistics/packages/'
    | '/_authenticated/settings/_layout/'
    | '/_super/super/control-panel/'
    | '/_authenticated/logistics/containers/$id/edit'
    | '/_authenticated/logistics/containers/_list/calendar'
    | '/_authenticated/logistics/containers/_list/kanban'
    | '/_authenticated/logistics/orders/$id/edit'
    | '/_super/super/control-panel/$companyId/history'
    | '/_super/super/control-panel/$companyId/overview'
    | '/_super/super/control-panel/$companyId/subscription'
    | '/_super/super/control-panel/$companyId/usage'
    | '/_super/super/control-panel/$companyId/users'
    | '/_authenticated/logistics/containers/_list/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  _404Route: typeof _404Route
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  HomeRoute: typeof HomeRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SuperRoute: typeof SuperRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_super': {
      id: '/_super'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SuperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home': {
      id: '/_home'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__404': {
      id: '/__404'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof _404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/waitlist': {
      id: '/_home/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof HomeWaitlistRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_authenticated/subscriptions': {
      id: '/_authenticated/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthenticatedSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscription-success': {
      id: '/_authenticated/subscription-success'
      path: '/subscription-success'
      fullPath: '/subscription-success'
      preLoaderRoute: typeof AuthenticatedSubscriptionSuccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/release-notes': {
      id: '/_authenticated/release-notes'
      path: '/release-notes'
      fullPath: '/release-notes'
      preLoaderRoute: typeof AuthenticatedReleaseNotesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logistics': {
      id: '/_authenticated/logistics'
      path: '/logistics'
      fullPath: '/logistics'
      preLoaderRoute: typeof AuthenticatedLogisticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/complete-profile': {
      id: '/_authenticated/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof AuthenticatedCompleteProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients': {
      id: '/_authenticated/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedClientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedClientsRoute
    }
    '/_super/super/waitlist': {
      id: '/_super/super/waitlist'
      path: '/super/waitlist'
      fullPath: '/super/waitlist'
      preLoaderRoute: typeof SuperSuperWaitlistRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/users': {
      id: '/_super/super/users'
      path: '/super/users'
      fullPath: '/super/users'
      preLoaderRoute: typeof SuperSuperUsersRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/subscriptions': {
      id: '/_super/super/subscriptions'
      path: '/super/subscriptions'
      fullPath: '/super/subscriptions'
      preLoaderRoute: typeof SuperSuperSubscriptionsRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/settings': {
      id: '/_super/super/settings'
      path: '/super/settings'
      fullPath: '/super/settings'
      preLoaderRoute: typeof SuperSuperSettingsRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/plans': {
      id: '/_super/super/plans'
      path: '/super/plans'
      fullPath: '/super/plans'
      preLoaderRoute: typeof SuperSuperPlansRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/dashboard': {
      id: '/_super/super/dashboard'
      path: '/super/dashboard'
      fullPath: '/super/dashboard'
      preLoaderRoute: typeof SuperSuperDashboardRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/companies': {
      id: '/_super/super/companies'
      path: '/super/companies'
      fullPath: '/super/companies'
      preLoaderRoute: typeof SuperSuperCompaniesRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/_layout': {
      id: '/_super/super/_layout'
      path: '/super'
      fullPath: '/super'
      preLoaderRoute: typeof SuperSuperLayoutRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_public/verify/$qrCode': {
      id: '/_public/verify/$qrCode'
      path: '/verify/$qrCode'
      fullPath: '/verify/$qrCode'
      preLoaderRoute: typeof PublicVerifyQrCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/track/$code': {
      id: '/_public/track/$code'
      path: '/track/$code'
      fullPath: '/track/$code'
      preLoaderRoute: typeof PublicTrackCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/sign-up': {
      id: '/_public/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof PublicAuthSignUpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/sign-in': {
      id: '/_public/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof PublicAuthSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/reset-password': {
      id: '/_public/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof PublicAuthResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/first-time-login': {
      id: '/_public/auth/first-time-login'
      path: '/auth/first-time-login'
      fullPath: '/auth/first-time-login'
      preLoaderRoute: typeof PublicAuthFirstTimeLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/settings/_layout': {
      id: '/_authenticated/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logistics/packages': {
      id: '/_authenticated/logistics/packages'
      path: '/packages'
      fullPath: '/logistics/packages'
      preLoaderRoute: typeof AuthenticatedLogisticsPackagesRouteImport
      parentRoute: typeof AuthenticatedLogisticsRoute
    }
    '/_authenticated/logistics/orders': {
      id: '/_authenticated/logistics/orders'
      path: '/orders'
      fullPath: '/logistics/orders'
      preLoaderRoute: typeof AuthenticatedLogisticsOrdersRouteImport
      parentRoute: typeof AuthenticatedLogisticsRoute
    }
    '/_authenticated/logistics/containers': {
      id: '/_authenticated/logistics/containers'
      path: '/containers'
      fullPath: '/logistics/containers'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersRouteImport
      parentRoute: typeof AuthenticatedLogisticsRoute
    }
    '/_authenticated/logistics/box-deliveries': {
      id: '/_authenticated/logistics/box-deliveries'
      path: '/box-deliveries'
      fullPath: '/logistics/box-deliveries'
      preLoaderRoute: typeof AuthenticatedLogisticsBoxDeliveriesRouteImport
      parentRoute: typeof AuthenticatedLogisticsRoute
    }
    '/_super/super/control-panel/': {
      id: '/_super/super/control-panel/'
      path: '/super/control-panel'
      fullPath: '/super/control-panel'
      preLoaderRoute: typeof SuperSuperControlPanelIndexRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_authenticated/settings/_layout/': {
      id: '/_authenticated/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/logistics/packages/': {
      id: '/_authenticated/logistics/packages/'
      path: '/'
      fullPath: '/logistics/packages/'
      preLoaderRoute: typeof AuthenticatedLogisticsPackagesIndexRouteImport
      parentRoute: typeof AuthenticatedLogisticsPackagesRoute
    }
    '/_authenticated/logistics/orders/': {
      id: '/_authenticated/logistics/orders/'
      path: '/'
      fullPath: '/logistics/orders/'
      preLoaderRoute: typeof AuthenticatedLogisticsOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedLogisticsOrdersRoute
    }
    '/_authenticated/logistics/order_payments/': {
      id: '/_authenticated/logistics/order_payments/'
      path: '/order_payments'
      fullPath: '/logistics/order_payments'
      preLoaderRoute: typeof AuthenticatedLogisticsOrder_paymentsIndexRouteImport
      parentRoute: typeof AuthenticatedLogisticsRoute
    }
    '/_authenticated/logistics/box-deliveries/': {
      id: '/_authenticated/logistics/box-deliveries/'
      path: '/'
      fullPath: '/logistics/box-deliveries/'
      preLoaderRoute: typeof AuthenticatedLogisticsBoxDeliveriesIndexRouteImport
      parentRoute: typeof AuthenticatedLogisticsBoxDeliveriesRoute
    }
    '/_super/super/control-panel/$companyId': {
      id: '/_super/super/control-panel/$companyId'
      path: '/super/control-panel/$companyId'
      fullPath: '/super/control-panel/$companyId'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_public/track/order/$code': {
      id: '/_public/track/order/$code'
      path: '/track/order/$code'
      fullPath: '/track/order/$code'
      preLoaderRoute: typeof PublicTrackOrderCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/settings/_layout/users': {
      id: '/_authenticated/settings/_layout/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/trash': {
      id: '/_authenticated/settings/_layout/trash'
      path: '/trash'
      fullPath: '/settings/trash'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutTrashRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/subscription': {
      id: '/_authenticated/settings/_layout/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutSubscriptionRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/shipping-routes': {
      id: '/_authenticated/settings/_layout/shipping-routes'
      path: '/shipping-routes'
      fullPath: '/settings/shipping-routes'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutShippingRoutesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/roles': {
      id: '/_authenticated/settings/_layout/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutRolesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/payment-methods': {
      id: '/_authenticated/settings/_layout/payment-methods'
      path: '/payment-methods'
      fullPath: '/settings/payment-methods'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutPaymentMethodsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/notifications': {
      id: '/_authenticated/settings/_layout/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/nomenclatures': {
      id: '/_authenticated/settings/_layout/nomenclatures'
      path: '/nomenclatures'
      fullPath: '/settings/nomenclatures'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutNomenclaturesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/logistics': {
      id: '/_authenticated/settings/_layout/logistics'
      path: '/logistics'
      fullPath: '/settings/logistics'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutLogisticsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/containers': {
      id: '/_authenticated/settings/_layout/containers'
      path: '/containers'
      fullPath: '/settings/containers'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutContainersRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/carriers': {
      id: '/_authenticated/settings/_layout/carriers'
      path: '/carriers'
      fullPath: '/settings/carriers'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCarriersRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/calendars': {
      id: '/_authenticated/settings/_layout/calendars'
      path: '/calendars'
      fullPath: '/settings/calendars'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCalendarsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/branches': {
      id: '/_authenticated/settings/_layout/branches'
      path: '/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutBranchesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/box-types': {
      id: '/_authenticated/settings/_layout/box-types'
      path: '/box-types'
      fullPath: '/settings/box-types'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutBoxTypesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/reports/$id/builder': {
      id: '/_authenticated/reports/$id/builder'
      path: '/$id/builder'
      fullPath: '/reports/$id/builder'
      preLoaderRoute: typeof AuthenticatedReportsIdBuilderRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/logistics/packages/$id': {
      id: '/_authenticated/logistics/packages/$id'
      path: '/$id'
      fullPath: '/logistics/packages/$id'
      preLoaderRoute: typeof AuthenticatedLogisticsPackagesIdRouteImport
      parentRoute: typeof AuthenticatedLogisticsPackagesRoute
    }
    '/_authenticated/logistics/orders/new': {
      id: '/_authenticated/logistics/orders/new'
      path: '/new'
      fullPath: '/logistics/orders/new'
      preLoaderRoute: typeof AuthenticatedLogisticsOrdersNewRouteImport
      parentRoute: typeof AuthenticatedLogisticsOrdersRoute
    }
    '/_authenticated/logistics/containers/new': {
      id: '/_authenticated/logistics/containers/new'
      path: '/new'
      fullPath: '/logistics/containers/new'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersNewRouteImport
      parentRoute: typeof AuthenticatedLogisticsContainersRoute
    }
    '/_authenticated/logistics/containers/_list': {
      id: '/_authenticated/logistics/containers/_list'
      path: ''
      fullPath: '/logistics/containers'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersListRouteImport
      parentRoute: typeof AuthenticatedLogisticsContainersRoute
    }
    '/_authenticated/logistics/containers/_list/': {
      id: '/_authenticated/logistics/containers/_list/'
      path: '/'
      fullPath: '/logistics/containers/'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersListIndexRouteImport
      parentRoute: typeof AuthenticatedLogisticsContainersListRoute
    }
    '/_super/super/control-panel/$companyId/users': {
      id: '/_super/super/control-panel/$companyId/users'
      path: '/users'
      fullPath: '/super/control-panel/$companyId/users'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdUsersRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/usage': {
      id: '/_super/super/control-panel/$companyId/usage'
      path: '/usage'
      fullPath: '/super/control-panel/$companyId/usage'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdUsageRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/subscription': {
      id: '/_super/super/control-panel/$companyId/subscription'
      path: '/subscription'
      fullPath: '/super/control-panel/$companyId/subscription'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdSubscriptionRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/overview': {
      id: '/_super/super/control-panel/$companyId/overview'
      path: '/overview'
      fullPath: '/super/control-panel/$companyId/overview'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdOverviewRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/history': {
      id: '/_super/super/control-panel/$companyId/history'
      path: '/history'
      fullPath: '/super/control-panel/$companyId/history'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdHistoryRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_authenticated/logistics/orders/$id/edit': {
      id: '/_authenticated/logistics/orders/$id/edit'
      path: '/$id/edit'
      fullPath: '/logistics/orders/$id/edit'
      preLoaderRoute: typeof AuthenticatedLogisticsOrdersIdEditRouteImport
      parentRoute: typeof AuthenticatedLogisticsOrdersRoute
    }
    '/_authenticated/logistics/containers/_list/kanban': {
      id: '/_authenticated/logistics/containers/_list/kanban'
      path: '/kanban'
      fullPath: '/logistics/containers/kanban'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersListKanbanRouteImport
      parentRoute: typeof AuthenticatedLogisticsContainersListRoute
    }
    '/_authenticated/logistics/containers/_list/calendar': {
      id: '/_authenticated/logistics/containers/_list/calendar'
      path: '/calendar'
      fullPath: '/logistics/containers/calendar'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersListCalendarRouteImport
      parentRoute: typeof AuthenticatedLogisticsContainersListRoute
    }
    '/_authenticated/logistics/containers/$id/edit': {
      id: '/_authenticated/logistics/containers/$id/edit'
      path: '/$id/edit'
      fullPath: '/logistics/containers/$id/edit'
      preLoaderRoute: typeof AuthenticatedLogisticsContainersIdEditRouteImport
      parentRoute: typeof AuthenticatedLogisticsContainersRoute
    }
  }
}

interface AuthenticatedClientsRouteChildren {
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
}

const AuthenticatedClientsRouteChildren: AuthenticatedClientsRouteChildren = {
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
}

const AuthenticatedClientsRouteWithChildren =
  AuthenticatedClientsRoute._addFileChildren(AuthenticatedClientsRouteChildren)

interface AuthenticatedLogisticsBoxDeliveriesRouteChildren {
  AuthenticatedLogisticsBoxDeliveriesIndexRoute: typeof AuthenticatedLogisticsBoxDeliveriesIndexRoute
}

const AuthenticatedLogisticsBoxDeliveriesRouteChildren: AuthenticatedLogisticsBoxDeliveriesRouteChildren =
  {
    AuthenticatedLogisticsBoxDeliveriesIndexRoute:
      AuthenticatedLogisticsBoxDeliveriesIndexRoute,
  }

const AuthenticatedLogisticsBoxDeliveriesRouteWithChildren =
  AuthenticatedLogisticsBoxDeliveriesRoute._addFileChildren(
    AuthenticatedLogisticsBoxDeliveriesRouteChildren,
  )

interface AuthenticatedLogisticsContainersListRouteChildren {
  AuthenticatedLogisticsContainersListCalendarRoute: typeof AuthenticatedLogisticsContainersListCalendarRoute
  AuthenticatedLogisticsContainersListKanbanRoute: typeof AuthenticatedLogisticsContainersListKanbanRoute
  AuthenticatedLogisticsContainersListIndexRoute: typeof AuthenticatedLogisticsContainersListIndexRoute
}

const AuthenticatedLogisticsContainersListRouteChildren: AuthenticatedLogisticsContainersListRouteChildren =
  {
    AuthenticatedLogisticsContainersListCalendarRoute:
      AuthenticatedLogisticsContainersListCalendarRoute,
    AuthenticatedLogisticsContainersListKanbanRoute:
      AuthenticatedLogisticsContainersListKanbanRoute,
    AuthenticatedLogisticsContainersListIndexRoute:
      AuthenticatedLogisticsContainersListIndexRoute,
  }

const AuthenticatedLogisticsContainersListRouteWithChildren =
  AuthenticatedLogisticsContainersListRoute._addFileChildren(
    AuthenticatedLogisticsContainersListRouteChildren,
  )

interface AuthenticatedLogisticsContainersRouteChildren {
  AuthenticatedLogisticsContainersListRoute: typeof AuthenticatedLogisticsContainersListRouteWithChildren
  AuthenticatedLogisticsContainersNewRoute: typeof AuthenticatedLogisticsContainersNewRoute
  AuthenticatedLogisticsContainersIdEditRoute: typeof AuthenticatedLogisticsContainersIdEditRoute
}

const AuthenticatedLogisticsContainersRouteChildren: AuthenticatedLogisticsContainersRouteChildren =
  {
    AuthenticatedLogisticsContainersListRoute:
      AuthenticatedLogisticsContainersListRouteWithChildren,
    AuthenticatedLogisticsContainersNewRoute:
      AuthenticatedLogisticsContainersNewRoute,
    AuthenticatedLogisticsContainersIdEditRoute:
      AuthenticatedLogisticsContainersIdEditRoute,
  }

const AuthenticatedLogisticsContainersRouteWithChildren =
  AuthenticatedLogisticsContainersRoute._addFileChildren(
    AuthenticatedLogisticsContainersRouteChildren,
  )

interface AuthenticatedLogisticsOrdersRouteChildren {
  AuthenticatedLogisticsOrdersNewRoute: typeof AuthenticatedLogisticsOrdersNewRoute
  AuthenticatedLogisticsOrdersIndexRoute: typeof AuthenticatedLogisticsOrdersIndexRoute
  AuthenticatedLogisticsOrdersIdEditRoute: typeof AuthenticatedLogisticsOrdersIdEditRoute
}

const AuthenticatedLogisticsOrdersRouteChildren: AuthenticatedLogisticsOrdersRouteChildren =
  {
    AuthenticatedLogisticsOrdersNewRoute: AuthenticatedLogisticsOrdersNewRoute,
    AuthenticatedLogisticsOrdersIndexRoute:
      AuthenticatedLogisticsOrdersIndexRoute,
    AuthenticatedLogisticsOrdersIdEditRoute:
      AuthenticatedLogisticsOrdersIdEditRoute,
  }

const AuthenticatedLogisticsOrdersRouteWithChildren =
  AuthenticatedLogisticsOrdersRoute._addFileChildren(
    AuthenticatedLogisticsOrdersRouteChildren,
  )

interface AuthenticatedLogisticsPackagesRouteChildren {
  AuthenticatedLogisticsPackagesIdRoute: typeof AuthenticatedLogisticsPackagesIdRoute
  AuthenticatedLogisticsPackagesIndexRoute: typeof AuthenticatedLogisticsPackagesIndexRoute
}

const AuthenticatedLogisticsPackagesRouteChildren: AuthenticatedLogisticsPackagesRouteChildren =
  {
    AuthenticatedLogisticsPackagesIdRoute:
      AuthenticatedLogisticsPackagesIdRoute,
    AuthenticatedLogisticsPackagesIndexRoute:
      AuthenticatedLogisticsPackagesIndexRoute,
  }

const AuthenticatedLogisticsPackagesRouteWithChildren =
  AuthenticatedLogisticsPackagesRoute._addFileChildren(
    AuthenticatedLogisticsPackagesRouteChildren,
  )

interface AuthenticatedLogisticsRouteChildren {
  AuthenticatedLogisticsBoxDeliveriesRoute: typeof AuthenticatedLogisticsBoxDeliveriesRouteWithChildren
  AuthenticatedLogisticsContainersRoute: typeof AuthenticatedLogisticsContainersRouteWithChildren
  AuthenticatedLogisticsOrdersRoute: typeof AuthenticatedLogisticsOrdersRouteWithChildren
  AuthenticatedLogisticsPackagesRoute: typeof AuthenticatedLogisticsPackagesRouteWithChildren
  AuthenticatedLogisticsOrder_paymentsIndexRoute: typeof AuthenticatedLogisticsOrder_paymentsIndexRoute
}

const AuthenticatedLogisticsRouteChildren: AuthenticatedLogisticsRouteChildren =
  {
    AuthenticatedLogisticsBoxDeliveriesRoute:
      AuthenticatedLogisticsBoxDeliveriesRouteWithChildren,
    AuthenticatedLogisticsContainersRoute:
      AuthenticatedLogisticsContainersRouteWithChildren,
    AuthenticatedLogisticsOrdersRoute:
      AuthenticatedLogisticsOrdersRouteWithChildren,
    AuthenticatedLogisticsPackagesRoute:
      AuthenticatedLogisticsPackagesRouteWithChildren,
    AuthenticatedLogisticsOrder_paymentsIndexRoute:
      AuthenticatedLogisticsOrder_paymentsIndexRoute,
  }

const AuthenticatedLogisticsRouteWithChildren =
  AuthenticatedLogisticsRoute._addFileChildren(
    AuthenticatedLogisticsRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedReportsIdBuilderRoute: typeof AuthenticatedReportsIdBuilderRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedReportsIdBuilderRoute: AuthenticatedReportsIdBuilderRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSettingsLayoutRouteChildren {
  AuthenticatedSettingsLayoutBoxTypesRoute: typeof AuthenticatedSettingsLayoutBoxTypesRoute
  AuthenticatedSettingsLayoutBranchesRoute: typeof AuthenticatedSettingsLayoutBranchesRoute
  AuthenticatedSettingsLayoutCalendarsRoute: typeof AuthenticatedSettingsLayoutCalendarsRoute
  AuthenticatedSettingsLayoutCarriersRoute: typeof AuthenticatedSettingsLayoutCarriersRoute
  AuthenticatedSettingsLayoutContainersRoute: typeof AuthenticatedSettingsLayoutContainersRoute
  AuthenticatedSettingsLayoutLogisticsRoute: typeof AuthenticatedSettingsLayoutLogisticsRoute
  AuthenticatedSettingsLayoutNomenclaturesRoute: typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  AuthenticatedSettingsLayoutNotificationsRoute: typeof AuthenticatedSettingsLayoutNotificationsRoute
  AuthenticatedSettingsLayoutPaymentMethodsRoute: typeof AuthenticatedSettingsLayoutPaymentMethodsRoute
  AuthenticatedSettingsLayoutRolesRoute: typeof AuthenticatedSettingsLayoutRolesRoute
  AuthenticatedSettingsLayoutShippingRoutesRoute: typeof AuthenticatedSettingsLayoutShippingRoutesRoute
  AuthenticatedSettingsLayoutSubscriptionRoute: typeof AuthenticatedSettingsLayoutSubscriptionRoute
  AuthenticatedSettingsLayoutTrashRoute: typeof AuthenticatedSettingsLayoutTrashRoute
  AuthenticatedSettingsLayoutUsersRoute: typeof AuthenticatedSettingsLayoutUsersRoute
  AuthenticatedSettingsLayoutIndexRoute: typeof AuthenticatedSettingsLayoutIndexRoute
}

const AuthenticatedSettingsLayoutRouteChildren: AuthenticatedSettingsLayoutRouteChildren =
  {
    AuthenticatedSettingsLayoutBoxTypesRoute:
      AuthenticatedSettingsLayoutBoxTypesRoute,
    AuthenticatedSettingsLayoutBranchesRoute:
      AuthenticatedSettingsLayoutBranchesRoute,
    AuthenticatedSettingsLayoutCalendarsRoute:
      AuthenticatedSettingsLayoutCalendarsRoute,
    AuthenticatedSettingsLayoutCarriersRoute:
      AuthenticatedSettingsLayoutCarriersRoute,
    AuthenticatedSettingsLayoutContainersRoute:
      AuthenticatedSettingsLayoutContainersRoute,
    AuthenticatedSettingsLayoutLogisticsRoute:
      AuthenticatedSettingsLayoutLogisticsRoute,
    AuthenticatedSettingsLayoutNomenclaturesRoute:
      AuthenticatedSettingsLayoutNomenclaturesRoute,
    AuthenticatedSettingsLayoutNotificationsRoute:
      AuthenticatedSettingsLayoutNotificationsRoute,
    AuthenticatedSettingsLayoutPaymentMethodsRoute:
      AuthenticatedSettingsLayoutPaymentMethodsRoute,
    AuthenticatedSettingsLayoutRolesRoute:
      AuthenticatedSettingsLayoutRolesRoute,
    AuthenticatedSettingsLayoutShippingRoutesRoute:
      AuthenticatedSettingsLayoutShippingRoutesRoute,
    AuthenticatedSettingsLayoutSubscriptionRoute:
      AuthenticatedSettingsLayoutSubscriptionRoute,
    AuthenticatedSettingsLayoutTrashRoute:
      AuthenticatedSettingsLayoutTrashRoute,
    AuthenticatedSettingsLayoutUsersRoute:
      AuthenticatedSettingsLayoutUsersRoute,
    AuthenticatedSettingsLayoutIndexRoute:
      AuthenticatedSettingsLayoutIndexRoute,
  }

const AuthenticatedSettingsLayoutRouteWithChildren =
  AuthenticatedSettingsLayoutRoute._addFileChildren(
    AuthenticatedSettingsLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedClientsRoute: typeof AuthenticatedClientsRouteWithChildren
  AuthenticatedCompleteProfileRoute: typeof AuthenticatedCompleteProfileRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedLogisticsRoute: typeof AuthenticatedLogisticsRouteWithChildren
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedReleaseNotesRoute: typeof AuthenticatedReleaseNotesRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSubscriptionSuccessRoute: typeof AuthenticatedSubscriptionSuccessRoute
  AuthenticatedSubscriptionsRoute: typeof AuthenticatedSubscriptionsRoute
  AuthenticatedSettingsLayoutRoute: typeof AuthenticatedSettingsLayoutRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedClientsRoute: AuthenticatedClientsRouteWithChildren,
  AuthenticatedCompleteProfileRoute: AuthenticatedCompleteProfileRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedLogisticsRoute: AuthenticatedLogisticsRouteWithChildren,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedReleaseNotesRoute: AuthenticatedReleaseNotesRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSubscriptionSuccessRoute: AuthenticatedSubscriptionSuccessRoute,
  AuthenticatedSubscriptionsRoute: AuthenticatedSubscriptionsRoute,
  AuthenticatedSettingsLayoutRoute:
    AuthenticatedSettingsLayoutRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface HomeRouteChildren {
  HomeWaitlistRoute: typeof HomeWaitlistRoute
  HomeIndexRoute: typeof HomeIndexRoute
}

const HomeRouteChildren: HomeRouteChildren = {
  HomeWaitlistRoute: HomeWaitlistRoute,
  HomeIndexRoute: HomeIndexRoute,
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)

interface PublicRouteChildren {
  PublicAuthFirstTimeLoginRoute: typeof PublicAuthFirstTimeLoginRoute
  PublicAuthResetPasswordRoute: typeof PublicAuthResetPasswordRoute
  PublicAuthSignInRoute: typeof PublicAuthSignInRoute
  PublicAuthSignUpRoute: typeof PublicAuthSignUpRoute
  PublicTrackCodeRoute: typeof PublicTrackCodeRoute
  PublicVerifyQrCodeRoute: typeof PublicVerifyQrCodeRoute
  PublicTrackOrderCodeRoute: typeof PublicTrackOrderCodeRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAuthFirstTimeLoginRoute: PublicAuthFirstTimeLoginRoute,
  PublicAuthResetPasswordRoute: PublicAuthResetPasswordRoute,
  PublicAuthSignInRoute: PublicAuthSignInRoute,
  PublicAuthSignUpRoute: PublicAuthSignUpRoute,
  PublicTrackCodeRoute: PublicTrackCodeRoute,
  PublicVerifyQrCodeRoute: PublicVerifyQrCodeRoute,
  PublicTrackOrderCodeRoute: PublicTrackOrderCodeRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface SuperSuperControlPanelCompanyIdRouteChildren {
  SuperSuperControlPanelCompanyIdHistoryRoute: typeof SuperSuperControlPanelCompanyIdHistoryRoute
  SuperSuperControlPanelCompanyIdOverviewRoute: typeof SuperSuperControlPanelCompanyIdOverviewRoute
  SuperSuperControlPanelCompanyIdSubscriptionRoute: typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  SuperSuperControlPanelCompanyIdUsageRoute: typeof SuperSuperControlPanelCompanyIdUsageRoute
  SuperSuperControlPanelCompanyIdUsersRoute: typeof SuperSuperControlPanelCompanyIdUsersRoute
}

const SuperSuperControlPanelCompanyIdRouteChildren: SuperSuperControlPanelCompanyIdRouteChildren =
  {
    SuperSuperControlPanelCompanyIdHistoryRoute:
      SuperSuperControlPanelCompanyIdHistoryRoute,
    SuperSuperControlPanelCompanyIdOverviewRoute:
      SuperSuperControlPanelCompanyIdOverviewRoute,
    SuperSuperControlPanelCompanyIdSubscriptionRoute:
      SuperSuperControlPanelCompanyIdSubscriptionRoute,
    SuperSuperControlPanelCompanyIdUsageRoute:
      SuperSuperControlPanelCompanyIdUsageRoute,
    SuperSuperControlPanelCompanyIdUsersRoute:
      SuperSuperControlPanelCompanyIdUsersRoute,
  }

const SuperSuperControlPanelCompanyIdRouteWithChildren =
  SuperSuperControlPanelCompanyIdRoute._addFileChildren(
    SuperSuperControlPanelCompanyIdRouteChildren,
  )

interface SuperRouteChildren {
  SuperSuperLayoutRoute: typeof SuperSuperLayoutRoute
  SuperSuperCompaniesRoute: typeof SuperSuperCompaniesRoute
  SuperSuperDashboardRoute: typeof SuperSuperDashboardRoute
  SuperSuperPlansRoute: typeof SuperSuperPlansRoute
  SuperSuperSettingsRoute: typeof SuperSuperSettingsRoute
  SuperSuperSubscriptionsRoute: typeof SuperSuperSubscriptionsRoute
  SuperSuperUsersRoute: typeof SuperSuperUsersRoute
  SuperSuperWaitlistRoute: typeof SuperSuperWaitlistRoute
  SuperSuperControlPanelCompanyIdRoute: typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  SuperSuperControlPanelIndexRoute: typeof SuperSuperControlPanelIndexRoute
}

const SuperRouteChildren: SuperRouteChildren = {
  SuperSuperLayoutRoute: SuperSuperLayoutRoute,
  SuperSuperCompaniesRoute: SuperSuperCompaniesRoute,
  SuperSuperDashboardRoute: SuperSuperDashboardRoute,
  SuperSuperPlansRoute: SuperSuperPlansRoute,
  SuperSuperSettingsRoute: SuperSuperSettingsRoute,
  SuperSuperSubscriptionsRoute: SuperSuperSubscriptionsRoute,
  SuperSuperUsersRoute: SuperSuperUsersRoute,
  SuperSuperWaitlistRoute: SuperSuperWaitlistRoute,
  SuperSuperControlPanelCompanyIdRoute:
    SuperSuperControlPanelCompanyIdRouteWithChildren,
  SuperSuperControlPanelIndexRoute: SuperSuperControlPanelIndexRoute,
}

const SuperRouteWithChildren = SuperRoute._addFileChildren(SuperRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  _404Route: _404Route,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  HomeRoute: HomeRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SuperRoute: SuperRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
